import React, { ReactNode } from "react";
import { useAuth } from "../hooks/auth";

interface PermissionComponentProps {
  type: string;
  caseType?: number;
  children: ReactNode;
}
const PermissionComponent = ({
  type,
  caseType,
  children,
}: PermissionComponentProps) => {
  let isAuth = false;
  const { user } = useAuth();
  const findRole = type ? type.split(",").includes(user.type) : true;
  isAuth = findRole;
  if(isAuth){
    const findCase = caseType ? user.case === caseType: true;
    isAuth =findCase
  }

  return <>{isAuth && children}</>;
};

export { PermissionComponent };
